<div id="report-content" dir="ltr">
  <div class="p-2 pt-0 container">
      <div class="card px-10 pb-10 pt-5" >
        <div class="grid grid grid-cols-2">
          <div>
            <div class="qr-code-container">
              <img *ngIf="qrCodeImage" [src]="qrCodeImage" alt="QR Code" />
            </div>
           
          </div>
    
          
          <div class="text-right body-1 flex flex-col items-end font-arabic">
            <!-- Image and Table Side by Side -->
              
           

            <div>
              <img src="assets/img/towa_logo.png" />

            </div>
           
    
            
          </div>
        </div>
    
        <div>
          <h1 class="font-arabic m-0 text-center flex items-center justify-center header" style="font-weight: bolder;line-height: normal;">امـــر بـــيع</h1>
        </div>

        <div class="grid grid-cols-2">
          <div class="text-right body-1 flex flex-col items-end mt-0 mr-20">
            <table >
              <tbody>
              <tr>
                <td class="text-right pr-4 "><div class="">             
                  <h1 class="font-arabic m-0 size-12">{{orderData?.customerName}} </h1>
                </div></td>
                  <td >                   <div class="text-right ">
                    <h1 class="font-arabic m-0 sub-header text-gray-500">اسـم الـعـمـيـل  </h1></div></td>
                
              </tr>
              <tr>
                <td class="text-right pr-4 "><div class="">             
                  <h1 class="font-arabic m-0 size-12">{{orderData?.customerCode}}</h1>
                </div></td>
                  <td >                   <div class="text-right ">
                    <h1 class="font-arabic m-0 sub-header text-gray-500">كــود الـعـمـيـل  </h1></div></td>
                
              </tr>
              <tr>
                <td class="text-right pr-4 size-12">{{selectedSalesMan?.userCode}} - {{selectedSalesMan?.userName}}</td>
                <td >
                  <div class="text-right "><h1 class="font-arabic m-0 sub-header text-gray-500">الـــبـــائـــع</h1></div>
                  </td>
              </tr>

              <!-- <tr>
                <td class="text-right pr-4 "><div>
                  <h1 class="m-0 mt-3 font-arabic " style="line-height: 20px;">{{orderData?.customerAddressName}} - {{orderData?.customerAddressCity}} - {{orderData?.customerAddressCountry}}</h1>
                </div></td>
                <td >
                  <div class="text-right "><h1 class="font-arabic m-0 sub-header text-gray-500">الـعــنـــوان</h1></div>
                  </td>
              </tr> -->
              </tbody>
            </table>
          </div>

          <div class="mt-0">
            <div class="text-right body-1 flex flex-col items-end">
              <table >
                <tbody>
                <tr>
                  <td class="text-right pr-4 size-12">{{orderData?.transactionNumber}}</td>
                    <td >                   <div class="text-right ">
                      <h1 class="font-arabic m-0 sub-header text-gray-500">رقم امـر البـــيع </h1></div></td>
                  
                </tr>
                <tr>
                  <td class="text-right pr-4 size-12">{{orderData?.transactionDate | date:'dd-MM-yyyy'}}</td>
                  <td >
                    <div class="text-right "><h1 class="font-arabic m-0 sub-header text-gray-500">الــتــاريـخ</h1></div>
                    </td>
                </tr>

                <tr>
                  <td class="text-right pr-4 "> <div class="">  
                    <h1 class="font-arabic m-0 size-12">{{selectedFactory?.code}} - {{selectedFactory?.name}}</h1></div></td>
                  <td >
                    <div class="text-right "><h1 class="font-arabic m-0 sub-header text-gray-500">الـمـصـنـع</h1></div>
                    </td>
                </tr>
                <tr>
                  <td class="text-right pr-4 "> <div class="">  
                    <h1 class="font-arabic m-0 size-12" >{{orderData?.notes}}</h1></div></td>
                  <td >
                    <div class="text-right "><h1 class="font-arabic m-0 sub-header text-gray-500">الــمــلاحظــات</h1></div>
                    </td>
                </tr>
                </tbody>
              </table>
            </div>
            <!-- <div class="text-right body-2">
              <h1 class="mt-0 font-arabic sub-header text-gray-500" style="font-weight: bold; ">الـمـصـنـع</h1>
            </div>
            <div class="text-right title">  
              <h1 class="font-arabic m-0 sub-header">{{orderData?.factoryName}} <span>
                <h1 class="font-arabic m-0 sub-header text-gray-500">- {{orderData?.factoryCode}} </h1>
              </span></h1>
                        
            </div> -->
            <!-- <h3 class="title m-0">{{orderData?.factoryName}}</h3> -->
            <!-- <div class="font-arabic">
              <p class="m-0">907 Eastern Pkwy</p>
              <p class="m-0">Brooklyn, NY</p>
              <p class="m-0">11213, USA</p>
  
              <p class="m-0 mt-3">
                <mat-icon class="mr-2 icon-sm" svgIcon="mat:mail"></mat-icon>
                <span>hello&#64;example.com</span>
              </p>
  
              <p class="m-0">
                <mat-icon class="mr-2 icon-sm" svgIcon="mat:phone"></mat-icon>
                <span>+1 (961) 400-3535</span>
              </p>
            </div> -->
          </div>
        </div>

        
        <table class="table w-full mt-5">
          <thead style="background-color: aliceblue;">
          <tr>
            <td>
              <div class="text-center body-2"><h1 class="font-arabic normalText">رقــم الـعــرض</h1></div>
            </td>
            <td>
              <div class="text-center body-2"><h1 class="font-arabic normalText">الاجــمــالي</h1></div>
            </td>
            <td>
              <div class="text-center body-2"><h1 class="font-arabic normalText">% الضــريــبــة</h1></div>
            </td>
            <td>
              <div class="text-center body-2"><h1 class="font-arabic normalText">ســعــر الــوحــدة</h1></div>

            </td>
            <td>
              <div class="text-center body-2"><h1 class="font-arabic normalText">الـكـمـيـة</h1></div>

            </td>
            <td>
              <div class="text-center body-2"><h1 class="font-arabic normalText">عـنـوان الـعـمـيـل</h1></div>

            </td>
            <td>
              <div class="text-center body-2"><h1 class="font-arabic normalText">الـوصـف</h1></div>

            </td>

            <td>
              <div class="text-center body-2"><h1 class="font-arabic normalText">الـمـنـتـج</h1></div>
            </td>

          </tr>
          </thead>
          <tbody *ngFor="let line of orderData?.salesOrderLines">
          <tr class="pb-1">
            <td class="pb-1 border-b text-center">
              <div class=" body-2" *ngIf="!line?.salesQuotationNumber"><h1 class="font-arabic normalText">لا يوجد</h1>
              </div>
              <div class=" body-2" *ngIf="line?.salesQuotationNumber"><h1 class="font-arabic normalText"> {{line?.itemName}}</h1>
              </div>
          </td>

            <td class="pb-1 border-b text-center normalText">{{line?.total}}</td>

            <td class="pb-1 border-b text-center normalText">{{line?.vatPercentage}}</td>
            <td class="pb-1 border-b text-center normalText">{{line?.unitPrice}}</td>
            <td class="pb-1 border-b text-center normalText">
              <span dir="rtl">
                <h1 class="font-arabic normalText">{{line?.quantity}} {{line?.uom}}</h1></span>
              </td>
              <td class=" border-b">
                <div class="flex justify-center items-center body-2"><h1 class="font-arabic m-0 normalText" *ngIf="line?.customerAddressId==-1">تسليم مصنع</h1></div>
                <div class="flex justify-center items-center body-2" *ngIf="!(line?.customerAddressId==-1)"><h1 class="font-arabic m-0 normalText">{{line?.addressName}}</h1></div>

                </td>
            <td class="pb-1 border-b">
              <div class="flex justify-center items-center body-2"><h1 class="font-arabic normalText"> {{line?.itemName}}</h1></div>
              </td>
            <td class="pb-1 border-b text-center normalText">{{line?.itemCode}} </td>

          </tr>
    
          <!-- <tr>
            <td class="py-6 border-b">
              Graphic Pack - Monthly Subscription (includes Updates)
            </td>
            <td class="py-6 border-b">$49.99</td>
            <td class="py-6 border-b">User</td>
          </tr>
    
          <tr>
            <td class="py-6 border-b">Logo & Branding Pack</td>
            <td class="py-6 border-b">$499.99</td>
            <td class="py-6 border-b">Piece</td>

          </tr>
    
          <tr>
            <td class="py-6 border-b">Bug Fixes</td>
            <td class="py-6 border-b">$15.00</td>
            <td class="py-6 border-b">Hour</td>

          </tr> -->
          </tbody>
        </table>

        
        <!-- <table class="table w-full mt-5 no-break">
          <thead style="background-color: aliceblue;">
          <tr>
            <td>
              <div class="text-center body-2"><h1 class="font-arabic normalText">الاجـمـالي</h1></div>
            </td>
            <td>
              <div class="text-center body-2" ><h1 class="font-arabic normalText">قـيـمـة الـضـريـبـة</h1></div>
            </td>

            <td>
              <div class="text-center body-2" ><h1 class="font-arabic normalText">% الضــريــبــة</h1></div>
            </td>
            <td>
              <div class="text-center body-2" ><h1 class="font-arabic normalText">الاجـمالي قـبـل الـضـريبة</h1></div>
            </td>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td class=" border-b text-center"><div class="text-center body-2"><h1 class="font-arabic normalText">{{orderData?.total}}</h1></div>
            </td>
            <td class=" border-b">
              <div class="text-center body-2"><h1 class="font-arabic normalText">{{orderData?.vatAmount}}</h1></div>
              </td>
            <td class=" border-b text-center normalText">{{orderData?.vatPercentage}}</td>
            <td class=" border-b text-center normalText">{{orderData?.totalBeforeVAT}}</td>

          </tr>
    
          </tbody>
        </table>  -->
       <hr/>
        <div class="grid grid-cols-2 mt-3 no-break mr-0 flex flex-col items-end">
          <div></div>
          <div class="text-center body-1 flex flex-col items-center mt-0">
            <table class="border-bottom">
              <tbody>
              <tr>
                <td class="text-right pr-4 "><div class="">             
                  <h1 class="font-arabic m-0 size-12">{{(orderData?.totalBeforeVAT | currency: 'SAR':'symbol':'1.0-4')?.replace('SAR', '') + ' SAR'}} </h1>
                </div></td>
                  <td >                   <div class="text-right ">
                    <h1 class="font-arabic m-0 sub-header text-gray-500">الاجـمالي قـبـل الـضـريبة </h1></div></td>
                
              </tr>
              <tr>
                <td class="text-right pr-4 "><div class="">             
                  <h1 class="font-arabic m-0 size-12">{{orderData?.vatPercentage}}</h1>
                </div></td>
                  <td >                   <div class="text-right ">
                    <h1 class="font-arabic m-0 sub-header text-gray-500">% الضــريــبــة </h1></div></td>
                
              </tr>
              <tr>
                <td class="text-right pr-4 size-12 font-arabic">{{(orderData?.vatAmount | currency: 'SAR':'symbol':'1.0-4')?.replace('SAR', '') + ' SAR'}}</td>
                <td >
                  <div class="text-right "><h1 class="font-arabic m-0 sub-header text-gray-500">قـيـمـة الـضـريـبـة</h1></div>
                  </td>
              </tr>

              <tr>
                <td class="text-right pr-4 size-12 font-arabic pb-3">{{(orderData?.total | currency: 'SAR':'symbol':'1.0-4')?.replace('SAR', '') + ' SAR'}}</td>
                <td>
                  <div class="text-right "><h1 class="font-arabic m-0 sub-header text-gray-500 pb-3"> الاجـمـالي</h1></div>
                  </td>
              </tr>
              </tbody>
            </table>
          </div>
        
      </div>
    </div>
    
</div>
